<template>
    <div v-loading="mixinLoading" style="min-height: 400px" class="bg-white">
        <template v-if="isPageAllowed">
            <div class="bg-color" style="padding-bottom: 10px;transition: none;">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab">
                        <template v-if="pageActionNames.includes('daily_task_page')">
                            <el-tab-pane label="Report Task List" name="task_page">
                                <TaskList v-if="activeTabName == 'task_page'" ref="taskListPage" :allowed-plat-list="allowedPlatList" :page-func-names="pageFuncNames" @toRecordPage="toRecordPage"/>
                            </el-tab-pane>
                            <el-tab-pane label="Task Generation Records" name="log_page">
                                <RecordListPage v-if="activeTabName == 'log_page'" ref="recordListPage" :page-func-names="pageFuncNames"/>
                            </el-tab-pane>
                            <el-tab-pane label="Template Management" name="template_page">
                                <TempListPage v-if="activeTabName == 'template_page'" ref="templateListPage" :allowedPlatList="allowedPlatList" :page-func-names="pageFuncNames" @toTaskPage="toTaskPage"/>
                            </el-tab-pane>
                        </template>
                    </el-tabs>
                </div>
                <!--<component :ref="activeTabName" :is="activeTabName" :page-func-names="pageFuncNames" :page-fields="pageFields" />-->
                <!-- <tag_management_page ref="tabPage" v-if="activeTabName=='tag_management_page'" :page-func-names="pageFuncNames" :page-fields="pageFields"/>
                <ListPage ref="listPage" v-else :page-func-names="pageFuncNames" :page-fields="pageFields" :api-type="apiType" /> -->

            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>Automated Reports Page</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {pageMixin} from './pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import TempListPage from './page/temp/list.vue';
    import RecordListPage from './page/record/list.vue';
    import TaskList from './page/task/list';
    import langEn from 'element-ui/lib/locale/lang/en';
    import langZh from 'element-ui/lib/locale/lang/zh-CN';
    import locale from 'element-ui/lib/locale';

    export default {
        name: "DailyTask",
        mixins: [pageMixin],
        components:{
            NoPermissionInfo,
            TempListPage,
            RecordListPage,
            TaskList,
        },
        data() {
            return {
                isPageAllowed: true,
                activeTabName:'task_page',
                isLoadActions:false,
            }
        },
        watch:{
            '$route'(to,from){
                /*处理同路由push不刷新问题*/
                if((to.name==from.name)&&(to.name=='daily_task')){
                    this.jumpToPage();
                }
            },
            pageActionNames(n) {
                if (n.includes('daily_task_page') ) {
                    this.activeTabName = 'task_page'
                };
                if (this.showConfig) {
                    this.activeTabName = 'config_page'
                }
                if (n.length) {
                    this.jumpToPage();
                }
            }
        },
        mounted(){
            /* 2024.11.28 临时测试效果，勿合  zql*/
            locale.use(langEn);
            // 此处判断页面是否需要隐藏侧边栏&顶栏
            let isHideTdBar = true;
            if(isHideTdBar){
                this.hideTdBar();
            }
        },
        computed: {
            // 是否显示配置页
            showConfig() {
                return ['file_whitelist_page', 'file_separate_queue_page'].some(v=> {
                    return this.pageActionNames.includes(v)
                })
            }
        },
        methods:{
            /* 2024.11.28  临时测试效果，勿合 zql*/
            hideTdBar(){
                $('body').addClass('jt-td-special-page-hide-menu');
            },
            showTdBar(){
                $('body').removeClass('jt-td-special-page-hide-menu');
            },


            jumpToPage(){
                /* 从消息中心/或其他页面 带着参数跳转来的 */

                let $routeParams = this.$route.params;
                let $routeQuery = this.$route.query;
                let pageType = $routeParams.pageType||$routeQuery.pageType||'';


                if(pageType=='daily_task_list'){
                    this.toTaskPage({
                        search:$routeParams.search||$routeQuery.search,
                    });
                }else if(pageType=='daily_task_detail'){
                    this.toTaskPage({
                        search:$routeParams.search||$routeQuery.search,
                        detail:true,
                    });
                }else if(pageType=='create_template'){
                    if(this.isLoadActions){
                        this.toTemplatePage({
                            platId:$routeQuery.platId,
                            toCreatePage:true,
                        });
                    }else{
                        setTimeout(()=>{
                            this.jumpToPage();
                        },500)
                    }
                }else if(pageType=='view_template'){
                    this.toTemplatePage($routeQuery);
                }else{
                    this.toTaskPage();
                }
            },
            changeTab(tab){
                let tabName = tab.name||'';
                if(tabName=='task_page'){
                    this.toTaskPage();
                }else if(tabName == 'log_page'){
                    this.toRecordPage();
                }else if(tabName == 'template_page'){
                    this.toTemplatePage();
                }
            },
            initPageStates(){
                console.log('initPageStates');
                console.log('pageFunc',this.pageFunc);
                console.log('pageFields',this.pageFields);
                this.isLoadActions = true;
            },
            toRecordPage(data={}){
                console.log(1,'toRecordPage',data);
                this.activeTabName = 'log_page';
                this.$nextTick(()=>{
                    this.$refs.recordListPage.searchList(data);
                });
            },
            toTaskPage(data={}){
                if (this.pageActionNames.includes('daily_task_page')) {
                    this.activeTabName = 'task_page';
                    this.$nextTick(()=>{
                        this.$refs.taskListPage.searchList(data);
                    }) 
                }
            },
            toTemplatePage(data={}){
                console.log(1,'toTemplatePage',data);
                this.activeTabName = 'template_page';
                this.$nextTick(()=>{
                    this.$refs.templateListPage.searchList(data);
                });
            },
        },

        /* 2024.11.28  临时测试效果，勿合 zql */
        beforeDestroy() {
            locale.use(langZh);
            this.showTdBar();
        },
    }
</script>

<style scoped>

</style>
